import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export const useScrollBottom = (messageStack) => {
  const botTyping = useSelector((state) => state.messageState.botTyping);
  const bottomRef = useRef(null);
  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messageStack, bottomRef, botTyping]);
  return bottomRef;
};
